import ReactSlider from 'react-slider';
import styled from 'styled-components';
import { SliderMixin } from '../../mixins/components/SliderMixin';
export var StyledSlider = /*#__PURE__*/styled(ReactSlider).withConfig({
  displayName: "StyledSlider",
  componentId: "c11n-8-111-1__sc-15y3zdh-0"
})(["", ""], SliderMixin);